<div class="container" *ngIf="hasFailedRecommits">
  <button (click)="navigateToFailedRecommits()" routerLinkActive="active-link">
    View Failed Recommits
  </button>
  <hr />
</div>

<div class="container">
  <div class="upload">
    <input type="button" class="btn" value="Attach" />
    <input
      #uploadFile
      type="file"
      name="files"
      id="fileUpload"
      input-file-model="files"
      (change)="fileChanged($event)"
      multiple="false"
    />
    <span class="fileName"> {{ fileName }}</span>
  </div>
  <div class="container" *ngIf="!isExcelFile">
    <label
      ><span class="not-sent"
        >* Select a valid Excel file to proceed</span
      ></label
    >
  </div>
  <div class="container" *ngIf="!isValidExcelFile">
    <label
      ><span class="errorTypeName" class="not-sent">{{
        errorMessage
      }}</span></label
    >
  </div>
  <div class="container" *ngIf="dataExist && isUploadFileSuccess">
    <label><span class="not-sent">File Uploaded Successfully</span></label>
  </div>
  <hr />
</div>
<mat-progress-bar
  *ngIf="isLoading === true"
  mode="indeterminate"
  color="accent"
></mat-progress-bar>
<div>
  <div class="container" *ngIf="!dataExist && isUploadFileSuccess">
    <label><span class="not-sent">* No Record to Display</span></label>
  </div>
  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
      <mat-cell *matCellDef="let order"> {{ order.email }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createDate">
      <mat-header-cell *matHeaderCellDef> Create Date </mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.createDate | date: "shortDate" }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="accountName">
      <mat-header-cell *matHeaderCellDef> Account Name </mat-header-cell>
      <mat-cell *matCellDef="let order"> {{ order.accountName }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="salesOrderNumber">
      <mat-header-cell *matHeaderCellDef> Sales Order Number </mat-header-cell>
      <mat-cell *matCellDef="let order">
        {{ order.salesOrderNumber }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      tabindex="0"
    ></mat-row>
  </mat-table>
  <div class="container">
    <p>
      <button
        id="btnSubmit"
        [disabled]="!dataExist || recordsSaved"
        type="button"
        class="btn btn-bump-right"
        (click)="submitData()"
      >
        Save & Process
      </button>
      <button id="btnCancel" type="button" class="btn" (click)="clearData()">
        Clear
      </button>
    </p>
  </div>
</div>
<div class="container" *ngIf="isUploadFileSuccess && recordsSaved">
  <label><span class="not-sent">Data Saved Successfully.</span></label>
</div>
